module.exports = __webpack_public_path__ + "img/shop2-1.abe58259.png";